module.exports = __webpack_public_path__ + "43cd6e187b7b64ba68eadc5496b7eacb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/link-banner.jpg
// module id = 108
// module chunks = 0